import { useState } from "react";
import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@material-ui/core";
import { AuthForm } from "pages/VisitPage/Forms/AuthForm";
import { localUserService } from "utils/localStorage";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useNav } from "hooks/useNav";
import Person from "@material-ui/icons/Person";
import { useTopHeadStyles } from "./styles";

export const Auth = () => {
  const classes = useTopHeadStyles();
  const [open, setOpen] = useState(false);
  const { viewAccount, viewSettings } = useNav();
  const { userData } = useTypeSelectors((state) => state.auth);
  const localAuthToken = localUserService.getAccess();
  const handleGotoAccount = () => {
    viewAccount();
    setAnchorEl(null);
  };
  const handleLogout = () => {
    localUserService.logout();
    setAnchorEl(null);
  };
  const handleGotoSettings = () => {
    viewSettings();
    setAnchorEl(null);
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box>
        {localAuthToken && (
          <Box className={classes.accSmallBox} onClick={handleClick}>
            <Box className={classes.accName}>
              <Typography variant="body1" className={classes.username}>
                {userData.first_name} {userData.last_name}
              </Typography>
              <Typography variant="body1" className={classes.role}>
                {userData.role_name}
              </Typography>
            </Box>
            <Avatar className={classes.avatar}>
              <Person className={classes.avatarIcon} />
            </Avatar>
          </Box>
        )}
      </Box>
      <Menu
        id="login-menu"
        anchorEl={anchorEl}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        
      >
        <MenuItem onClick={handleGotoAccount}>My account</MenuItem>
        <MenuItem onClick={handleGotoSettings}>Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box>
          <AuthForm />
        </Box>
      </Modal>
    </div>
  );
};
